import type { TemplateDataType } from "client-server-shared/template-data";
import React from "react";

export const TemplateContext = React.createContext<{
  template: TemplateDataType;
} | null>(null);
export const useTemplate = () => React.useContext(TemplateContext)!.template!;
